import { getAllUsersAsch, getAllRolesByAchs, updateRolWorker, getRolUserSelected } from "../../../../services/rolesApi";
import { GetOfficeAchs } from "../../../../services/aperturas"
import { openCloseToast } from "../../../Global/actions";
import trace from "../../../../helpers/trace";

export const setDataListas = (list) => ({
  type: "SET_LISTA_TRABAJADORES_ACHS",
  list,
});

export const setDataRoles = (list) => ({
  type: "SET_LISTA_ROLES_ACHS",
  list,
});

export const loading = (isLoading) => ({
  type: "LOADING_ROLES_ACHS",
  isLoading,
});

export const setDataRolesUserSelected = (data) => ({
  type: "SET_DATA_ROLES_USER_SELECTED_ACHS",
  data
})

export const cleanState = () => ({
  type: "RESET_STATE_USERS_ACHS"
})

export const getTrabajadoresAchs = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const usuarios = await getAllUsersAsch();
    if (usuarios.status === 200) {
      const result = await usuarios.json();
      dispatch(setDataListas(result.Data));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al cargar los usuario",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al obtener usuarios",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
}

export const setRolesTrabajadores = (data, closeModal) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const usuarios = await updateRolWorker(data);
    if (usuarios.status === 200) {
      const result = await usuarios.json();
      closeModal()
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Roles asignados correctamente.",
        typeStyle: "success",
        displayTime: 5000
      }));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al asignar roles",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al asignar roles",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
}

export const getAllRolesByAchsAction = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const roles = await getAllRolesByAchs();
    if (roles.status === 200) {
      const result = await roles.json();
      const offices = await getAchsOfficeAction();
      var lista = [];
      if(result.Data && offices){
        result.Data.forEach((e, i) =>{
          e.expanded= false;
          e.newId = e.Id;
          if(e.AdminAchsOffices){
            let _list = offices.map(ee => {
              return {
                newId: e.Id+"_"+ee.Id,
                categoryId: e.Id,
                expanded: false,
                Name: ee.Description,
                ...ee
              }
            })
            lista = [...lista, ...[e], ..._list]
          }else{
            lista = [...lista, ...[e]];
          }
        })
      }else if(result.Data){
        lista = result.Data
      }
      dispatch(setDataRoles(lista));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al cargar los roles",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch {
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al obtener roles",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
}

const getAchsOfficeAction = async () => {
  try {
    const roles = await GetOfficeAchs();
    if (roles.status === 200) {
      const result = await roles.json();
      return result;
    } else {
      return null
    }
  } catch {
    return null
  }
}

export const getRolesUserSelected = (data, setDataSelected) => async(dispatch) =>{
  try {
    dispatch(loading(true));
    const usuarios = await getRolUserSelected(data.rut);
    if (usuarios.status === 200) {
      const result = await usuarios.json();
      data.roles = result.Data;
      setDataSelected(data)
      //dispatch(setDataRolesUserSelected(result.Data));
    } else {
      dispatch(openCloseToast({
        isToastOpen: true,
        msgToast: "Error al cargar el usuario",
        typeStyle: "error",
        displayTime: 5000
      }));
    }
  } catch (e){
    trace.error("getRolesUserSelected", e);
    dispatch(openCloseToast({
      isToastOpen: true,
      msgToast: "Error de conexión al obtener usuario",
      typeStyle: "error",
      displayTime: 5000
    }));
  }
  dispatch(loading(false));
}
